const useImpersonateUser = (eventId) => 
{
  const login = (type, token, eventId) => {
    if (type === "PARENTS") {
      window.open(
        `${process.env.REACT_APP_PARENTS_PORTAL_URL}/impersonate?token=${token}&eventId=${eventId}`,
        '_blank'
      ).focus()
    }

    if (type === "STAFF") {
      sessionStorage.setItem('impersonatorToken', sessionStorage.getItem('adminToken'))
      sessionStorage.setItem('adminToken', token)
      sessionStorage.setItem('impersonated', true)
      sessionStorage.setItem('impersonationActivatedFromLink', window.location.href)
      window.location.href = `/event/${eventId}/schedule`
    }
  }

  const logoutStaff = () => {
    let redirectUrl = "/"

    if (typeof window === 'undefined') return; // SSR guard

    const impersonatorToken = sessionStorage.getItem('impersonatorToken')
    sessionStorage.removeItem('impersonated')
    sessionStorage.removeItem('impersonatorToken')
    
    if (impersonatorToken) {
      sessionStorage.setItem('adminToken', impersonatorToken);
    } else {
      sessionStorage.removeItem('adminToken');
    }

    if (sessionStorage.getItem('impersonationActivatedFromLink')) {
      redirectUrl = sessionStorage.getItem('impersonationActivatedFromLink')
      sessionStorage.removeItem('impersonationActivatedFromLink')
    }

    window.location.href = redirectUrl
  }

  return { login, logoutStaff }
}

export default useImpersonateUser

